export const sortUploadsByStatus = (state, uploads) => {
    state.visModActiveIds = [];
    state.visModSavedIds = [];

    uploads.forEach(({ id, status }) => {
        if (status === "VISUAL_MOD") {
            state.visModActiveIds.push(id);
        }

        if (status === "VISUAL_MOD_SAVED_FOR_LATER") {
            state.visModSavedIds.push(id);
        }
    });

    state.visModActiveIds = state.visModActiveIds.sort();
    state.visModSavedIds = state.visModSavedIds.sort();
};
